/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {QrCode} from './components/QrCode';
import {DeepLinkHandler} from './components/MobileDeepLinkHandler';

const App = () => {
  const [useNewFlow, setUseNewFlow] = useState(false);

  useEffect(() => {
    // Check environment variable for default flow
    const envUseNewFlow = process.env.REACT_APP_USE_NEW_FLOW === 'true';
    
    // Check URL path and query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const flowParam = urlParams.get('flow');
    const path = window.location.pathname;
    
    let initialFlow = envUseNewFlow; // Use env variable as default
    
    // URL parameter overrides environment variable
    if (flowParam === 'new') {
      initialFlow = true;
    } else if (flowParam === 'old') {
      initialFlow = false;
    }
    
    // Console property overrides everything
    if (window.USE_NEW_FLOW !== undefined) {
      initialFlow = window.USE_NEW_FLOW;
    }
    
    setUseNewFlow(initialFlow);
    
    // Make toggle function available globally
    window.toggleFlow = (value) => {
      setUseNewFlow(value);
      console.log(`Switched to: ${value ? 'MobileDeepLinkHandler' : 'QrCode'}`);
    };
    
    console.log('Flow configuration:');
    console.log(`Environment default: ${envUseNewFlow ? 'MobileDeepLinkHandler' : 'QrCode'}`);
    console.log('Override options:');
    console.log('1. Console: window.toggleFlow(true/false)');
    console.log('2. Query Param: ?flow=new or ?flow=old');
    console.log(`Current flow: ${initialFlow ? 'MobileDeepLinkHandler' : 'QrCode'}`);
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.innerContainer}>
        {useNewFlow ? <DeepLinkHandler /> : <QrCode />}
      </div>
    </div>
  );
};

export default App;

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    // backgroundColor: '#f5f5f5',
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 640
  }
};
